import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';

const BASE_URL = process.env.REACT_APP_BASE_URL || 'https://www.echt.gold';

const Datenschutz = () => {
  return (
    <>
      <Helmet>
        <title>Datenschutzerklärung - Echt Gold</title>
        <meta name="description" content="Datenschutzerklärung von Echt Gold - Informationen zum Datenschutz und zur Datenverarbeitung." />
        <link rel="canonical" href={`${BASE_URL}/datenschutz`} />
      </Helmet>

      <div className="bg-black/90 py-8 border-b border-gold/20">
        <div className="container mx-auto px-4">
          <div className="text-sm text-gray-400 mb-2">
            <Link to="/" className="hover:text-gold">Home</Link> / <span className="text-gold">Datenschutz</span>
          </div>
          <h1 className="text-4xl md:text-5xl font-bold gold-text">Datenschutzerklärung</h1>
        </div>
      </div>

      <section className="section section-dark">
        <div className="container">
          <div className="max-w-4xl mx-auto">
            <div className="card space-y-6 text-gray-300">
              <div>
                <h2 className="text-2xl font-bold mb-4 gold-text">1. Datenschutz auf einen Blick</h2>
                <h3 className="text-xl font-bold mb-2 gold-text">Allgemeine Hinweise</h3>
                <p>
                  Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können.
                </p>
              </div>

              <div>
                <h3 className="text-xl font-bold mb-2 gold-text">Datenerfassung auf dieser Website</h3>
                <p className="mb-2"><strong>Wer ist verantwortlich für die Datenerfassung auf dieser Website?</strong></p>
                <p className="mb-4">
                  Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen Kontaktdaten können Sie dem Impressum dieser Website entnehmen.
                </p>

                <p className="mb-2"><strong>Wie erfassen wir Ihre Daten?</strong></p>
                <p className="mb-4">
                  Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei kann es sich z. B. um Daten handeln, die Sie in ein Kontaktformular eingeben. Andere Daten werden automatisch beim Besuch der Website durch unsere IT-Systeme erfasst.
                </p>

                <p className="mb-2"><strong>Wofür nutzen wir Ihre Daten?</strong></p>
                <p>
                  Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung der Website zu gewährleisten. Andere Daten können zur Analyse Ihres Nutzerverhaltens verwendet werden.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold mb-4 gold-text">2. Hosting</h2>
                <p>
                  Wir hosten die Inhalte unserer Website bei folgenden Anbietern. Die von Ihnen auf dieser Website erfassten Daten werden auf den Servern des Hosters gespeichert.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold mb-4 gold-text">3. Allgemeine Hinweise und Pflichtinformationen</h2>
                <h3 className="text-xl font-bold mb-2 gold-text">Datenschutz</h3>
                <p className="mb-4">
                  Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend der gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerklärung.
                </p>

                <h3 className="text-xl font-bold mb-2 gold-text">Hinweis zur verantwortlichen Stelle</h3>
                <p className="mb-2">
                  Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:
                </p>
                <p className="mb-4">
                  Echt Gold<br />
                  Neben dem Brand 10<br />
                  44135 Dortmund<br />
                  Telefon: 0231 39085116<br />
                  E-Mail: Info@echtgold.de
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold mb-4 gold-text">4. Datenerfassung auf dieser Website</h2>
                <h3 className="text-xl font-bold mb-2 gold-text">Kontaktformular</h3>
                <p>
                  Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold mb-4 gold-text">5. Ihre Rechte</h2>
                <p>
                  Sie haben jederzeit das Recht:
                </p>
                <ul className="list-disc ml-6 mt-2 space-y-1">
                  <li>unentgeltlich Auskunft über Herkunft, Empfänger und Zweck Ihrer gespeicherten personenbezogenen Daten zu erhalten</li>
                  <li>eine Berichtigung oder Löschung dieser Daten zu verlangen</li>
                  <li>unter bestimmten Umständen die Einschränkung der Verarbeitung Ihrer Daten zu verlangen</li>
                  <li>der Verarbeitung Ihrer Daten zu widersprechen</li>
                  <li>sich bei einer Aufsichtsbehörde zu beschweren</li>
                </ul>
              </div>

              <p className="text-sm text-gray-400 mt-8">
                Stand: November 2024<br />
                Diese Datenschutzerklärung ist als Muster zu verstehen und sollte an die individuellen Gegebenheiten angepasst werden.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Datenschutz;